<template>
  <section class="l-container catalog-container constructor_section">
    <constructor-components-section-header
      :title="data.title"
      :goto="data.goto"
    />
    <UiHorizontalScroll class="categories">
      <ConstructorComponentsCatalogListItem
        v-for="(item, index) in data.children"
        :category="item"
        :key="`${index}_${item.category_id}`"
      />
    </UiHorizontalScroll>
  </section>
</template>

<script setup lang="ts">
import type { CatalogListBlock } from '~/interfaces/constructor';

defineProps({
  data: {
    type: Object as () => CatalogListBlock,
    required: true,
  },
});
</script>
<style lang="scss" src="./CatalogListScss.scss" scoped></style>
